(function () {
  'use strict';

  var nav         = document.getElementById('ls-mob-nav');
  var l1Panel     = nav && nav.querySelector('.ls-mob-nav__panel--l1');
  var headerTitle = nav && nav.querySelector('.ls-mob-nav__header-title');
  var backBtn     = nav && nav.querySelector('.ls-mob-nav__back');
  var closeBtn    = nav && nav.querySelector('.ls-mob-nav__x');
  var overlay     = nav && nav.querySelector('.ls-mob-nav__overlay');
  var openBtns    = document.querySelectorAll('[data-ls-mob-toggle]');
  var currentL2   = null;
  var scrollLocked = false;

  if (!nav) return;

  function lockScroll() {
    scrollLocked = true;
    var y = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top      = '-' + y + 'px';
    document.body.style.left     = '0';
    document.body.style.right    = '0';
    document.body.dataset.scrollY = y;
  }

  function unlockScroll() {
    scrollLocked = false;
    var y = parseInt(document.body.dataset.scrollY || '0', 10);
    document.body.style.position = '';
    document.body.style.top      = '';
    document.body.style.left     = '';
    document.body.style.right    = '';
    window.scrollTo(0, y);
  }

  function openNav() {
    nav.style.display = 'block';
    void nav.offsetHeight; // force reflow so transition fires from translateX(-100%)
    nav.classList.add('is-open');
    lockScroll();
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }

  function closeNav() {
    if (currentL2) resetDrill();
    nav.classList.remove('is-open');
    setTimeout(function () {
      if (!nav.classList.contains('is-open')) nav.style.display = '';
    }, 280);
    unlockScroll();
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  function resetDrill() {
    if (!currentL2) return;
    currentL2.classList.remove('is-active');
    currentL2.setAttribute('aria-hidden', 'true');
    if (l1Panel) l1Panel.classList.remove('is-drilled');
    if (backBtn) backBtn.style.display = 'none';
    if (headerTitle) headerTitle.textContent = 'Menu';
    currentL2 = null;
  }

  function drillInto(key, label) {
    var l2 = nav.querySelector('[data-panel="' + key + '"]');
    if (!l2) return;
    currentL2 = l2;
    if (l1Panel) l1Panel.classList.add('is-drilled');
    l2.classList.add('is-active');
    l2.setAttribute('aria-hidden', 'false');
    if (backBtn) backBtn.style.display = 'flex';
    if (headerTitle) headerTitle.textContent = label || key;
  }

  openBtns.forEach(function (btn) { btn.addEventListener('click', openNav); });
  if (closeBtn) closeBtn.addEventListener('click', closeNav);
  if (overlay)  overlay.addEventListener('click', closeNav);
  if (backBtn)  backBtn.addEventListener('click', resetDrill);

  nav.querySelectorAll('[data-ls-drill]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      drillInto(btn.dataset.lsDrill, btn.dataset.lsDrillLabel);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  // ── Mobile search ───────────────────────────────────────
  var mobSearchForm    = document.querySelector('[data-ls-mob-search]');
  var mobSearchInput   = mobSearchForm && mobSearchForm.querySelector('.hn__mob-search-input');
  var mobSearchClear   = mobSearchForm && mobSearchForm.querySelector('.hn__mob-search-clear');
  var mobSPanel        = document.getElementById('ls-mob-search-panel');
  var mobSOverlay      = document.getElementById('ls-mob-search-overlay');


  if (mobSearchInput && mobSPanel) {
    var _scfg = window.lsSearchConfig || {};

    // Prevent iOS auto-zoom (triggered when input font-size < 16px) by temporarily
    // setting maximum-scale=1 on touchstart — before the focus event fires.
    var _origViewportContent = null;
    function lockViewportZoom() {
      if (_origViewportContent !== null) return;
      var vp = document.querySelector('meta[name="viewport"]');
      if (!vp) return;
      _origViewportContent = vp.content;
      vp.content = 'width=device-width, initial-scale=1, maximum-scale=1';
    }
    function unlockViewportZoom() {
      if (_origViewportContent === null) return;
      var vp = document.querySelector('meta[name="viewport"]');
      if (vp) vp.content = _origViewportContent;
      _origViewportContent = null;
    }
    mobSearchInput.addEventListener('touchstart', lockViewportZoom, { passive: true });
    var POPULAR = (_scfg.popularTerms || 'Shampoo|Hair mask|Conditioner|Face cream|Perfume|Vitamin C serum|Body lotion|Hair oil|Serum|Sunscreen').split('|');
    var POPULAR_LABEL = _scfg.popularLabel || 'Popular searches';
    var searchDebounce = null;

    function escStr(str) {
      return String(str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function fmtMoney(price) {
      var n = parseFloat(price);
      return isNaN(n) ? '' : n.toFixed(2).replace('.', ',') + ' €';
    }

    function thumbUrl(p) {
      var raw = p.image || p.featured_image;
      if (!raw) return '';
      var url = (typeof raw === 'string') ? raw : raw.url;
      if (!url) return '';
      if (url.indexOf('//') === 0) url = 'https:' + url;
      return url.split('?')[0] + '?width=120';
    }

    function mobSUrl(q) {
      return (window.routes ? window.routes.searchUrl : '/search')
        + '?q=' + encodeURIComponent(q) + '&options[prefix]=last';
    }

    function setPanelMaxHeight(panelTop) {
      var vvh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      mobSPanel.style.maxHeight = Math.max(200, vvh - panelTop - 8) + 'px';
    }

    function openMobSearch() {
      var mobBarEl = document.querySelector('.hn__mob-bar');
      var panelTop = mobBarEl ? Math.round(mobBarEl.getBoundingClientRect().bottom) : 56;
      mobSPanel.style.top = panelTop + 'px';
      if (mobSOverlay) mobSOverlay.style.top = panelTop + 'px';
      setPanelMaxHeight(panelTop);
      mobSPanel.classList.add('is-open');
      mobSPanel.setAttribute('aria-hidden', 'false');
      if (mobSOverlay) mobSOverlay.classList.add('is-open');
      mobSearchForm.classList.add('is-active');
      lockScroll();
      if (!mobSearchInput.value.trim()) showMobPopular();
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        if (!mobSPanel.classList.contains('is-open')) return;
        var panelTop = parseInt(mobSPanel.style.top, 10) || 56;
        setPanelMaxHeight(panelTop);
      });
    }

    function closeMobSearch() {
      mobSPanel.classList.remove('is-open');
      mobSPanel.setAttribute('aria-hidden', 'true');
      if (mobSOverlay) mobSOverlay.classList.remove('is-open');
      mobSearchForm.classList.remove('is-active');
      unlockScroll();
      unlockViewportZoom();
    }

    function syncMobClear() {
      mobSearchForm.classList.toggle('has-value', mobSearchInput.value.length > 0);
    }

    function showMobPopular() {
      var html = '<div class="ls-mob-search__inner"><p class="ls-mob-search__label">' + POPULAR_LABEL + '</p><div class="ls-mob-search__chips">';
      POPULAR.forEach(function (t) {
        html += '<button type="button" class="ls-mob-search__chip" data-term="' + escStr(t) + '">' + escStr(t) + '</button>';
      });
      html += '</div></div>';
      mobSPanel.innerHTML = html;
      mobSPanel.querySelectorAll('[data-term]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          mobSearchInput.value = btn.dataset.term;
          syncMobClear();
          mobSearchInput.focus();
          fetchMobResults(btn.dataset.term);
        });
      });
    }

    function fetchMobResults(q) {
      if (!q) { showMobPopular(); return; }
      var pUrl = '/search/suggest.json'
        + '?q=' + encodeURIComponent(q)
        + '&resources[type]=product'
        + '&resources[limit]=9'
        + '&resources[options][prefix]=last'
        + '&resources[options][fields]=title,product_type,variants.title,vendor,tag,body';
      var cUrl = '/search?section_id=ls-search-count&q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last';
      Promise.all([
        fetch(pUrl, { credentials: 'same-origin' }).then(function (r) { return r.json(); }),
        fetch(cUrl, { credentials: 'same-origin' }).then(function (r) { return r.text(); })
      ]).then(function (results) {
        var products = (results[0].resources && results[0].resources.results && results[0].resources.results.products) || [];
        var match = results[1].match(/>\s*(\d+)\s*</);
        var total = match ? parseInt(match[1], 10) : null;
        renderMobResults(products, q, total);
      }).catch(function () { renderMobNoResults(q); });
    }

    function renderMobResults(products, q, total) {
      if (!products.length) { renderMobNoResults(q); return; }
      var label = total !== null ? String(total) : (products.length >= 9 ? '9+' : String(products.length));
      var html = '<div class="ls-mob-search__inner"><p class="ls-mob-search__label">Products</p><div class="ls-mob-search__results">';
      products.forEach(function (p) {
        var src   = thumbUrl(p);
        var price = p.price ? fmtMoney(p.price) : '';
        html += '<a class="ls-mob-search__result" href="' + escStr(p.url) + '">';
        html += src
          ? '<div class="ls-mob-search__result-img"><img src="' + escStr(src) + '" alt="" width="56" height="56" loading="lazy"></div>'
          : '<div class="ls-mob-search__result-img ls-mob-search__result-img--empty"></div>';
        html += '<div class="ls-mob-search__result-info">';
        if (p.vendor) html += '<span class="ls-mob-search__result-vendor">' + escStr(p.vendor) + '</span>';
        html += '<span class="ls-mob-search__result-title">' + escStr(p.title) + '</span>';
        if (price)    html += '<span class="ls-mob-search__result-price">' + price + '</span>';
        html += '</div></a>';
      });
      html += '</div><a class="ls-mob-search__view-all" href="' + escStr(mobSUrl(q)) + '">View all results for &ldquo;' + escStr(q) + '&rdquo; (' + label + ') &rarr;</a></div>';
      mobSPanel.innerHTML = html;
    }

    function renderMobNoResults(q) {
      mobSPanel.innerHTML = '<div class="ls-mob-search__inner"><p class="ls-mob-search__no-results">No results for "<strong>' + escStr(q) + '</strong>"</p>'
        + '<a class="ls-mob-search__view-all" href="' + escStr(mobSUrl(q)) + '">Search all content &rarr;</a></div>';
    }

    mobSearchInput.addEventListener('focus', function () {
      if (!mobSPanel.classList.contains('is-open')) openMobSearch();
    });

    mobSearchInput.addEventListener('input', function () {
      if (!mobSPanel.classList.contains('is-open')) openMobSearch();
      syncMobClear();
      clearTimeout(searchDebounce);
      var q = mobSearchInput.value.trim();
      searchDebounce = setTimeout(function () { fetchMobResults(q); }, 220);
    });

    if (mobSearchClear) {
      mobSearchClear.addEventListener('click', function () {
        mobSearchInput.value = '';
        syncMobClear();
        closeMobSearch();
        mobSearchInput.blur();
      });
    }

    mobSearchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeMobSearch(); mobSearchInput.blur(); }
    });

    mobSearchForm.addEventListener('submit', function () { closeMobSearch(); });

    mobSearchInput.addEventListener('blur', function () {
      setTimeout(function () {
        var active = document.activeElement;
        if (active === mobSearchInput) return;
        if (!mobSPanel.contains(active)) closeMobSearch();
      }, 200);
    });

    if (mobSOverlay) mobSOverlay.addEventListener('click', function () {
      closeMobSearch();
      mobSearchInput.blur();
    });
  }
})();
